import App from '../../client/shared/pages/app'
import HomePage from '../../client/shared/pages/home/homePage'
import LandingPage from '../../client/shared/pages/landing/landingPage'
import NotFoundPage from '../../client/shared/pages/notFoundPage'
import SearchPage from '../../client/v1/pages/search'

import createAppContainer from '../../client/shared/containers/appContainer'
import createHomePageContainer from '../../client/shared/containers/homePageContainer'
import createLandingPageContainer from '../../client/shared/containers/landingPageContainer'
import createNotFoundContainer from '../../client/shared/containers/notFoundContainer'
import createSearchPageContainer from '../../client/shared/containers/searchPageContainer'

import searchRoutes from './search.new'

const SearchPageContainer = createSearchPageContainer(SearchPage)

import { RouteConfig } from 'react-router-config'

const routeConfig: RouteConfig[] = [
  {
    component: createAppContainer(App),
    path: '/',
    routes: [
      {
        component: createHomePageContainer(HomePage),
        exact: true,
        path: '/'
      },
      {
        component: createLandingPageContainer(LandingPage),
        path: '/free/:page'
      },
      ...searchRoutes.map(route => ({
        ...route,
        component: SearchPageContainer
      })),
      {
        component: createNotFoundContainer(NotFoundPage),
        path: '/*'
      }
    ]
  }
]

export default routeConfig
